import { Yup } from "components/DynamicForm/utils";
import { COURIERS, DELIVERY_DETAILS_ELEMENT_TYPE, DYNAMIC_TYPE_INPUT_TYPE, IVA_PERCENTAGES_CODES, JSON_TABLE_INPUT_TYPE, SELECT_INPUT_TYPE } from "utils/Constants";
import DynamicFormOptions from "utils/DynamicFormOptions";

const form = {
    sections: [{
        hideBorderBottom: false,
        fields: [
            [
                {
                    "type": "text",
                    "name": "secuencia",
                    "disabled": true,
                    "label": "Secuencia",
                    "sizing": {
                        "sm": 4
                    }
                },
                {
                    "type": "text",
                    "disabled": true,
                    "name": "warehouseNumber",
                    "label": "Warehouse Number",
                    "sizing": {
                        "sm": 4
                    }
                },
            ],
            [
                {
                    "type": "text",
                    "disabled": true,
                    "name": "provedor",
                    "label": "Proveedor"
                },
                {
                    "type": "text",
                    "disabled": true,
                    "name": "client",
                    "label": "Client"
                },
            ],
            [
                {
                    "type": "text",
                    "disabled": true,
                    "name": "tracking_num",
                    "label": "Numero Tracking",
                    "sizing": {
                        "sm": 5
                    }
                },
                {
                    "type": SELECT_INPUT_TYPE,
                    "disabled": true,
                    "name": "courier",
                    "creatable": true,
                    "label": "Transportista",
                    "options": COURIERS
                },
                {
                    "type": "money",
                    "disabled": true,
                    "name": "cost",
                    "label": "Precio",
                    "isDecimal": true,
                    "step": ".01",
                    "sizing": {
                        "sm": 3
                    }
                },
            ],
            [
                {
                    "type": DYNAMIC_TYPE_INPUT_TYPE,
                    "name": "measures",
                    "label": "Medidas",
                    "disabled": true,
                    "dynamicType": "text",
                    "options": {
                        "cm": "cm",
                        "in": "inch",
                    },
                    "defaultOption": "cm"
                },
                {
                    "type": DYNAMIC_TYPE_INPUT_TYPE,
                    "dynamicType": "number",
                    "name": "weigth",
                    "min": "0",
                    "step": ".01",
                    "disabled": true,
                    "label": "Peso",
                    "options": {
                        "lb": "Lbs",
                        "kg": "Kg",
                    },
                    "defaultOption": "lb"
                },
                {
                    "type": DYNAMIC_TYPE_INPUT_TYPE,
                    "name": "vweigth",
                    "dynamicType": "number",
                    "min": "0",
                    "step": ".01",
                    "disabled": true,
                    "label": "Peso Volumentrico",
                    "options": {
                        "ft³": "ft³",
                        "vlb": "Vlb",
                    },
                    "defaultOption": "ft³"
                },
            ],
        ]
    },
    {
        hideBorderBottom: false,
        fields: [
            [
                {
                    "type": DELIVERY_DETAILS_ELEMENT_TYPE,
                    "name": "tipo_transporte",
                    "disabled": true,
                    "legend": "Direccion de Entrega",
                    "sizing": {
                        "sm": 4
                    }
                },
            ]
        ]
    },
    {
        hideBorderBottom: true,
        fields: [
            [
                {
                    "type": SELECT_INPUT_TYPE,
                    "name": "priceType",
                    "creatable": false,
                    "label": "Tipo de Precio",
                    "sizing": {
                        "sm": 5
                    },
                    "optionsFunction": DynamicFormOptions.priceType
                },
                {
                    "type": "money",
                    "name": "exchangeRate",
                    "validation": Yup.number().required().positive(),
                    "description": "Tipo de Cambio del dia de hoy ",
                    "label": "Tipo de Cambio",
                    "isDecimal": true,
                    "min": "0",
                    "placeholder": "0,00",
                    "step": ".01",
                    "sizing": {
                        "sm": {
                            "size": 3,
                            "offset": 4
                        }
                    }
                },
            ],
            [
                {
                    "type": JSON_TABLE_INPUT_TYPE,
                    "name": "data",
                    "showDivisor": false,
                    "legend": "Detalle de Costo",
                    "validation": Yup.string().required("REQUIRED_JSON_TABLE_ERROR"),
                    "dataSchema": {
                        "codigo": {
                            "label": "Cod",
                            "type": "text",
                            "headingWidth": "col-1",
                        },
                        "description": {
                            "label": "Description",
                            "type": "text",
                            "min": "0",
                            "headingWidth": "col-5",
                        },
                        "cant": {
                            "label": "Cant",
                            "type": "number",
                            "min": "0",
                            "headingWidth": "col-1",
                        },
                        "price": {
                            "label": "Precio",
                            "type": "money",
                            "step": ".01",
                            "isDecimal": true,
                            "headingWidth": "col-2",
                        },
                        "iva": {
                            "label": "Iva",
                            "type": SELECT_INPUT_TYPE,
                            "options": IVA_PERCENTAGES_CODES,
                            "headingWidth": "col-2",
                        },
                        "comision": {
                            "label": "Comision",
                            "type": "number",
                            "isDecimal": true,
                            "suffix": "%",
                            "step": ".1",
                            "min": "0",
                            "max": "100",
                            "onTableInput": true,
                            "headingWidth": "col-1",
                        },
                        "discount": {
                            "label": "Descuento",
                            "type": "number",
                            "isDecimal": true,
                            "suffix": "%",
                            "step": ".1",
                            "min": "0",
                            "max": "100",
                            "onTableInput": true,
                            "headingWidth": "col-1",
                        }
                    },
                },
            ]
        ]
    }]
};

export default form;